import React, { Fragment } from "react";
import { ArticleSpots, spotProps } from "@modules/ArticleSpots/ArticleSpots";

export interface SectionsPageProps {
  spots: spotProps[];
}

const SectionsPage: React.FC<SectionsPageProps> = ({ spots }) => {
  const spotsUpdatedValue = spots.map(item => {
    item.TeaserText = item.TeaserText.replace(/(<([^>]+)>)/gi, "");
    return item;
  });
  const threeFirstItems = spotsUpdatedValue.splice(0, 3);
  return (
    <Fragment>
      <ArticleSpots spots={threeFirstItems} gridMode="FocusMode" />
      <ArticleSpots spots={spotsUpdatedValue} gridMode="3ColumnMode" />
    </Fragment>
  );
};

export { SectionsPage };
